export const gameDefaults = {
    startVideo: '/video/intro.mp4',
    endVideo: '/video/final.mp4',
    checkpoints: [
        {
            id: 'genio_1',
            name: 'Genio',
            clue: 'Busca a una misteriosa figura flotante por la calle de los Remedios.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isUncompleted('genio_1')
                ],
                accesibleOn: [
                    isNearOf('genio_1')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/El_Genio.mp3',
                    title: 'El Genio de Los Realejos',
                    content: [
                        { text: 'Cuenta la leyenda que el Genio existe antes de que Los Realejos tuviera ese nombre, es un ser mágico y misterioso que aparece cuando menos lo esperas en el municipio.' },
                        { text: 'El Genio de Los Realejos fue un personaje creado por José Cívico y Porto, administrador de la Hacienda de Los Príncipes, para una obra teatral titulada la Loa a la Cruz con destino a las fiestas de la Santa Cruz que se celebraban en la ermita de San Sebastián en 1869.' },
                        { image: '/images/hitos/Genio.jpg' },
                        { text: 'Este personaje como se describe en el libreto era un venerable anciano vestido con pieles, con un bastón y con corona de ramas. Tenía el conocimiento de toda la historia del lugar desde el origen de los tiempos hasta el presente.' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'El Genio',
                    src: '/chats/genio1.json',
                    events: [
                        {
                            onNodeAdded: ['si'],
                            success: true
                        }
                    ]
                },
            },
            marker: {
                image: '/images/game/genio.png',
                width: 50,
                height: 50 * (209 / 125),
            },
            position: {
                lon: -16.58422,
                lat: 28.38056,
            },
        },
        {
            id: 'ganadero',
            name: 'Ganadero',
            clue: 'Se oyen gritos... ¡Novelera! ¡Novelera!',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('genio_1')
                ],
                accesibleOn: [
                    isNearOf('ganadero')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Feria_ganado.mp3',
                    title: 'Feria de ganado',
                    content: [
                        { text: 'Vacas, cabras, caballos, bueyes, podencos y hasta aves rapaces se dan cita en este encuentro celebrado en el municipio. La Feria de Ganado de las Fiestas de Mayo de Los Realejos se realiza en el entorno de la Finca El Llano, en donde se desarrollan multitud de actividades como muestra de gastronomía local, exposición y demostración de maquinaria agrícola, exhibición de juegos tradicionales, etc.' },
                        { image: '/images/hitos/feria_ganado.jpg' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'Ganadero',
                    src: '/chats/ganadero.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/ganadero.svg',
                width: 50,
                height: 50 * (158.861 / 103.818),
            },
            position: {
                lon: -16.58357,
                lat: 28.38021,
            },
        },
        {
            id: 'parrandero',
            name: 'Parrandero',
            clue: 'Está piripi pero sabe lo que dice.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('genio_1')
                ],
                accesibleOn: [
                    isNearOf('parrandero')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Romeria_chica.mp3',
                    title: 'Romería chica',
                    content: [
                        { text: 'La Romería Chica en honor a San Isidro Labrador, santo patrón de las labores del campo, es una de las citas más entrañables de las Fiestas de Mayo en Los Realejos. El culto a San Isidro se remonta en Los Realejos desde 1676 cuando fue colocada su imagen en el templo del Apóstol Santiago.' },
                        { image: '/images/hitos/romeria_chica.jpg' },
                        { text: 'Se celebra una  eucaristía y un paseo romero con carretas y parrandas, donde no falta la música popular de las islas y la degustación de vinos y productos típicos de la gastronomía canaria.' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'Parrandero',
                    src: '/chats/parrandero.json',
                    events: [
                        {
                            onNodeAdded: ['dialogo1', 'dialogo2'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/parrandero.svg',
                width: 50,
                height: 50 * (161.443 / 97.283),
            },
            position: {
                lon: -16.583834883774784,
                lat: 28.380011003860847,
            },
        },
        {
            id: 'genio_2',
            name: 'Genio',
            clue: 'El genio tiene una nueva pista.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('ganadero', 'parrandero'),
                    isUncompleted('genio_2'),
                ],
                accesibleOn: [
                    isNearOf('genio_2')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Genio',
                    src: '/chats/genio2.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/images/game/genio.png',
                width: 50,
                height: 50 * (209 / 125),
            },
            position: {
                lon: -16.584092739506715,
                lat: 28.379279568676324,
            },
        },
        {
            id: 'capilla_calle_sol',
            name: 'Capilla Calle El Sol',
            clue: 'Busca la “casa” de la cruz del Sol.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [
                    isCompleted('genio_2'),
                    isNearOf('capilla_calle_sol')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Capilla_Sol.mp3',
                    title: 'Capilla del Sol',
                    content: [
                        { text: 'La calle El Sol, antiguamente conocida como de La Lagaña, era otro de los caseríos que conformaban el antiguo núcleo urbano del Realejo de Arriba. En ella residían personas de múltiples oficios y condición, en sencillas viviendas al margen de las grandes extensiones de terreno de haciendas y fincas limítrofes, como “El Cercado”, “Piloto” o “El Llano”.' },
                        { text: 'Hacia 1864, gracias a la generosidad de sus vecinos, se construye una capilla  para colocar el Santo Madero, que desde tiempo atrás recibía culto en la calle. Dos años después obtienen licencia para poder celebrar misa en la recién construida capilla.' },
                        { image: '/images/hitos/capilla_sol.jpg' },
                        { text: 'En su altar interior preside el Santo Madero cubierto de plata, ricamente ornamentado con creativos enrames de flores durante todo el año, siendo su fiesta principal la Invención de la Cruz el tres de mayo.' },
                    ]
                },
                secret: {
                    isCompleted: false,
                    title: 'Capilla de Sol',
                    statement: '¿Qué imagen está representada en la intersección de la cruz de la capilla de la calle del Sol?',
                    image: '/game_images/capilla-calle-sol.png',
                    patterns: fullMatch('sol', 'un sol', 'el sol')
                },
                image360: {
                    isCompleted: false,
                    title: 'La ermita',
                    image: '/images/hitos/ermita_sol/360.jpg',
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.58409471084255,
                lat: 28.378506729318424,
            },
        },
        {
            id: 'vecina_sol',
            name: 'Vecina de Sol',
            clue: 'La vecina de esta calle, te dará una buena pista.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('capilla_calle_sol')
                ],
                accesibleOn: [
                    isCompleted('capilla_calle_sol'),
                    isNearOf('vecina_sol')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Vecina de Sol',
                    src: '/chats/sol_vecino.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/vecina_sol.svg',
                width: 50,
                height: 50 * (147.831 / 91.972),
            },
            position: {
                lon: -16.584144896895364,
                lat: 28.377816330912495,
            },
        },
        {
            id: 'frontera_calle',
            name: 'Frontera',
            clue: 'Busca la frontera entre el “Sol” y el “Medio”.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('vecina_sol'),
                    isNearOf('frontera_calle')
                ],
                accesibleOn: [
                    isCompleted('vecina_sol'),
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Pique.mp3',
                    title: 'El Pique',
                    content: [
                        { text: 'Algunos estudiosos apuntan que este “pique” se remonta al siglo XVIII y a la existencia de dos clases sociales bien diferenciadas: los propietarios de las tierras por donde discurría la calle de El Medio o calle Real, y los medianeros y pequeños campesinos de la calle de El Sol.' },
                        { image: '/images/hitos/pique.jpg' },
                        { text: 'Así, el “pique” o la sana rivalidad entre ambas calles podría estar asociado a ese simulado enfrentamiento entre “marqueses” y campesinos. La porfía consistía en que al paso de la Cruz en procesión, cada calle se adornaba y se quemaban fuegos a modo de ofrenda. El paso del tiempo y la evolución de los fuegos de artificio se ha visto reflejado en el pique entre ambas calles, que pasaron a vivir auténticas batallas campales con petardos y voladores que surcaban el cielo en horizontal buscando la calle “enemiga”, hasta los elaborados espectáculos pirotécnicos de la actualidad.' },
                    ]
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.584807996540697,
                lat: 28.3772116097445,
            },
        },
        {
            id: 'capilla_calle_medio',
            name: 'Capilla calle del Medio',
            clue: 'Visita la capilla con un altar escalonado.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [
                    isCompleted('frontera_calle'),
                    isNearOf('capilla_calle_medio')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Capilla_Medio.mp3',
                    title: 'Capilla Del Medio',
                    content: [
                        { text: 'El establecimiento poblacional junto a la iglesia del Apóstol Santiago y el camino que subía a la cumbre, fue el origen de esta calle que recibe su nombre por encontrarse en una lomada en medio de dos barrancos. En su recorrido nos encontramos con sobresaliente arquitectura de los siglos XVIII y XIX, levantada gracias al asentamiento de destacadas familias de la localidad.' },
                        { image: '/images/hitos/capilla_medio.jpg' },
                        { text: 'Desde finales del siglo XVI se conoce la existencia de una Cruz en un lugar muy cercano al actual, junto al camino que sube a La Romera. No será hasta finales del siglo XIX cuando se construya una capilla para cobijar el Santo Madero, anterior a la que hoy conocemos edificada en 1991.' },
                        { text: 'En su interior la Santa Cruz, pintada de verde y blanco, preside un altar escalonado preparado para recibir artísticas ornamentaciones florales durante su festividad del tres de mayo.' },
                    ]
                },
                secret: {
                    isCompleted: false,
                    title: 'Capilla Calle del Medio',
                    statement: '¿Cuál es el color predominante de la cruz de la capilla de la calle del Medio?',
                    image: '/game_images/capilla-calle-medio.jpg',
                    patterns: fullMatch('verde', 'es verde')
                },
                image360: {
                    isCompleted: false,
                    title: 'Capilla Del Medio',
                    image: '/images/hitos/ermita_el_medio/360.jpg'
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.585452555170495,
                lat: 28.377306219677706,
            },
        },
        {
            id: 'vecino_medio',
            name: 'Vecino del medio',
            clue: 'Este vecino de la calle del Medio, sabe muchas cosas.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('capilla_calle_medio')
                ],
                accesibleOn: [
                    isCompleted('capilla_calle_medio'),
                    isNearOf('vecino_medio')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Vecino del Medio',
                    src: '/chats/medio_vecino.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/vecino_medio.svg',
                width: 50,
                height: 50 * (142.777 / 87.647),
            },
            position: {
                lon: -16.58522091948333,
                lat: 28.378424918481105,
            },
        },
        {
            id: 'genio_3',
            name: 'Genio',
            clue: 'El genio quiere decirte algo.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('vecino_medio'),
                    isUncompleted('genio_3')
                ],
                accesibleOn: [
                    isNearOf('genio_3')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Genio',
                    src: '/chats/genio3.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/images/game/genio.png',
                width: 50,
                height: 50 * (209 / 125),
            },
            position: {
                lon: -16.585250000154627,
                lat: 28.37944955594635,
            },
        },
        {
            id: 'herreño',
            name: 'Gabetera',
            clue: 'Una chica vestida con ropas blancas.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('genio_3')
                ],
                accesibleOn: [
                    isCompleted('genio_3'),
                    isNearOf('herreño')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Hierro.mp3',
                    title: 'Chácaras y Tambores',
                    content: [
                        { text: 'Durante décadas, cada mes de mayo, gaveteros (gentilicio de los habitantes de Sabinosa) y realejeros se funden en un sentido abrazo cultural a través de la música popular, hermanando las islas de El Hierro y de Tenerife en las Fiestas de Mayo.' },
                        { image: '/images/hitos/hierro.jpg' },
                        { text: 'Son momentos muy especiales, en donde los herreños y herreñas participan en los eventos programados en estas fiestas, con sus cantos y bailes en la noche del festival musical que homenajea a todo el archipiélago, con su acompañamiento con pitos, chácaras, tambores y sus particulares danzas en Romería y la emotiva entrada de los santos a la iglesia matriz del Apóstol Santiago a su término.' },
                    ]
                },
                secret: {
                    isCompleted: false,
                    title: 'Sabinosa',
                    statement: 'Observa bien la escultura honorífica en favor del pueblo herreño de Sabinosa ¿Cuántas clases de instrumentos hay?',
                    image: '/game_images/estatua_el_hierro.jpg',
                    patterns: [
                        ['tres', 'i'],
                        ['3'],
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'Gabetera',
                    src: '/chats/herreno.json',
                    events: [
                        {
                            onNodeAdded: ['si'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/del_hierro.svg',
                width: 50,
                height: 50 * (162.278 / 109.036),
            },
            position: {
                lon: -16.58545278177039,
                lat: 28.38049713811047,
            },
        },
        {
            id: 'cura',
            name: 'Cura',
            clue: 'Te ayudará a seguir tu camino.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('herreño')
                ],
                accesibleOn: [
                    isCompleted('herreño'),
                    isNearOf('cura')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Cura',
                    src: '/chats/cura.json',
                    events: [
                        {
                            onNodeAdded: ['si'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/cura.svg',
                width: 50,
                height: 50 * (149.887 / 99.107),
            },
            position: {
                lon: -16.5851,
                lat: 28.38056
            },
        },
        {
            id: 'busto_viera',
            name: 'Busto Viera y Clavijo',
            clue: 'Busca el rastro de un hombre del pasado versado en muchas disciplinas.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('cura'),
                    isNearOf('busto_viera')
                ],
                accesibleOn: [
                    isCompleted('cura'),
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Jose_Viera_Clavijo.mp3',
                    title: 'Busto de José Antonio Viera y Clavijo',
                    content: [
                        { text: 'José de Viera y Clavijo, nace el 28 de diciembre de 1731 en una modesta casa del Realejo de Arriba, que aún se conserva.' },
                        { text: 'De origen humilde, fue un hombre ilustrado que dejó un enorme legado de conocimiento en campos tan variados como la poesía, teología, historia o biología. Tuvo una vida intelectualmente apasionante, sacerdote inquieto y talentoso, de humor satírico, se nutrió desde niño con las lecturas de los pensadores europeos más sobresalientes de la época. Era un gran pensador y excelente comunicador, que pese a su procedencia humilde pronto empezó a formar parte de los círculos culturales más aventajados de Canarias.' },
                        { text: 'Su busto de bronce fue colocado en la plaza de su nombre en 1927, obra del escultor José María Perdigón.' },
                        { image: '/images/hitos/viera.JPG' },
                    ]
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.585712395646112,
                lat: 28.380826173143824,
            },
        },
        {
            id: 'iglesia',
            name: 'Parroquia Matriz del Apóstol Santiago',
            clue: 'Una visita al interior del templo puede ser buena idea.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [
                    isCompleted('busto_viera'),
                    isNearOf('iglesia')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Iglesia.mp3',
                    title: 'Parroquia de Santiago Apóstol',
                    content: [
                        { text: 'Los inicios de este templo se vinculan con el fin de la conquista de las islas en 1496. Una primitiva ermita daría paso, décadas después, a un templo de mayores proporciones, con tres naves, capillas colaterales y sacristías en su cabecera. Sus portadas de cantería son de las primeras fases constructivas del templo, siendo la más antigua la del costado norte, fechada en 1521. Asimismo destaca la techumbre de la capilla mayor, con decoración mudéjar. La torre rematada por un puntiagudo chapitel se construye en 1774.' },
                        { image: '/images/hitos/iglesia.jpg' },
                        { text: 'En su interior encontramos importantes muestras del arte canario de los siglos XVII y XVIII como retablos, esculturas y pinturas. Fue declarada Monumento Nacional en 1983.' },
                    ]
                },
                secret: {
                    isCompleted: false,
                    title: 'Santiago Apóstol',
                    statement: '¿Cuántos peldaños tiene la escalinata a la entrada trasera de esta iglesia?',
                    image: '/game_images/iglesia.png',
                    patterns: [
                        ['seis', 'i'],
                        ['6'],
                    ]
                },
                image360: {
                    isCompleted: false,
                    title: 'Iglesia Santiago Apostol',
                    image: '/images/hitos/iglesia_santiago_apostol/360.jpg'
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.58518142653462,
                lat: 28.38086090742305,
            },
        },
        {
            id: 'musica',
            name: 'Música de la banda',
            clue: 'Suena una trompeta de procesión.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('iglesia')
                ],
                accesibleOn: [
                    isCompleted('iglesia'),
                    isNearOf('musica')
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Procesion_Remedios.mp3',
                    title: 'Procesión a Nuestra Señora de los Remedios',
                    content: [
                        { text: 'Desde finales del siglo XVI hay noticias del culto a Nuestra Señora de los Remedios en Los Realejos, una devoción que acumula siglos de historia y sitúa la venerada imagen en el sentir del pueblo realejero.' },
                        { image: '/images/hitos/procesion_remedios.jpg' },
                        { text: 'Las Fiestas de Mayo acaban con la esperada y concurrida celebración litúrgica y procesión de Nuestra Señora de Los Remedios, un acto que ha generado innumerables vivencias, anécdotas y testimonios dignos de ser recordados en el tiempo a través de numerosas generaciones.' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'Música de la banda',
                    src: '/chats/musico.json',
                    events: [
                        {
                            onNodeAdded: ['si'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/musica.svg',
                width: 50,
                height: 50 * (148.474 / 109.079),
            },
            position: {
                lon: -16.584976647410993,
                lat: 28.380747078392066,
            },
        },
        {
            id: 'caladora',
            name: 'Caladora',
            clue: 'Una mujer vestida de maga ha visto algo.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('musica')
                ],
                accesibleOn: [
                    isCompleted('musica'),
                    isNearOf('caladora')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Caladora',
                    src: '/chats/caladora.json',
                    events: [
                        {
                            onNodeAdded: ['si'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/costurera.svg',
                width: 50,
                height: 50 * (150.338 / 99.686),
            },
            position: {
                lon: -16.584793207428273,
                lat: 28.379973019879216,
            },
        },
        {
            id: 'vaca',
            name: 'Novelera',
            clue: '¡Una vaca anda suelta!',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('caladora'),
                    isNearOf('vaca')
                ],
                accesibleOn: [
                    isCompleted('caladora'),
                ],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Vaca.mp3',
                    title: 'Novelera',
                    content: [
                        { text: 'El sector primario en el municipio de Los Realejos ocupa un papel importante en la estructura productiva. La ganadería local está representada por explotaciones sobre todo de porcino, vacuno y de caprino, y en menor número explotaciones avícolas, luego nos encontramos con gran cantidad de ganado mular y caballar el cual se utiliza aún para trabajar la tierra, entre otras actividades.' },
                        { image: '/images/hitos/ganado.jpg' },
                        { text: 'Las explotaciones ganaderas son un tipo de explotaciones familiares las cuales se ubican cerca de los terrenos cultivados y en los que la actividad ganadera es complementaria de la agrícola.' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'Novelera',
                    src: '/chats/vaca.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/game_images/characters/vaca.svg',
                width: 80,
                height: 80 * (139.037 / 152.273),
            },
            position: {
                lon: -16.58313,
                lat: 28.38013,
            },
        },
        {
            id: 'genio_4',
            name: 'Genio',
            clue: 'Entrégale las piezas y salva las fiestas.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [
                    isCompleted('vaca'),
                    isUncompleted('genio_4')
                ],
                accesibleOn: [
                    isCompleted('vaca'),
                    isNearOf('genio_4')
                ],
            },
            activities: {
                chat: {
                    isCompleted: false,
                    title: 'Genio',
                    src: '/chats/genio4.json',
                    events: [
                        {
                            onNodeAdded: ['si', 'no'],
                            success: true
                        }
                    ]
                }
            },
            marker: {
                image: '/images/game/genio.png',
                width: 50,
                height: 50 * (209 / 125),
            },
            position: {
                lon: -16.58308,
                lat: 28.37995,
            },
        },
    ]
};
function isNearOf(targetId) {
    return {
        targets: [targetId],
        distance: 20,
    };
}
function isCompleted(...targets) {
    return {
        targets,
        isCompleted: true
    };
}
function isUncompleted(...targets) {
    return {
        targets,
        isCompleted: false
    };
}
function fullMatch(...strings) {
    return strings.map(s => [`^${s}$`, 'i']);
}
function createInfoMarker() {
    const width = 30;
    return {
        image: '/game_images/characters/info.svg',
        width: width,
        height: width * (130.748 / 81.134),
    };
}
